import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const activisionsSlice = createSlice({
  name: "activisions",
  initialState,
  reducers: {
    activisionsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    activisionsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setActivisionsList(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { activisionsLoading, activisionsError, setActivisionsList } =
  activisionsSlice.actions;

export default activisionsSlice.reducer;
